/*
    公司的axios 必然走的是封装
    axios.get axios.post axios.create()
*/ 
import axios from "axios";
import {GetCookie , setnullString} from "../config/config"
// axios用来调接口
// axios和ajax的区别 axios是ajax的promise的封装
// .then() .catch() promise
// axios自带了拦截器 对于数据请求前的拦截和数据返回后的拦截
// request是axios的数据发送前的拦截器

axios.interceptors.request.use(config=>{
    console.log(config)
    // 放行
    if(GetCookie("token")){
        // 如果缓存里面有token将Token放入后端告诉的头部地方
        config.headers.Authorization= GetCookie("token")
    }
    return config
})
// response是axios的数据发送回来后的拦截器
axios.interceptors.response.use(res=>{
    console.log(res)
    // if(res.status == 200){
    //     // 请求成功
    //     return res.data
    // }else{
    //     // 请求失败 
    //     // 404 路由跳转时不让 没权限 没登录 黑名单  （401 402 403 405权限问题 ）
    //     // 500 请求失败 接口报错 宕机 端网  (500 501 502 503)
    // }
    if(res.status ==200){
        res.data = setnullString(res.data)
    }
    return res
})
//抛出axios
export default axios




// WEBPACK FOOTER //
// ./src/config/axios.js